// Remove only identifiers used by the former Bill-Physio consent/GA integration.
function $0847d0cef0fc0611$export$1d29986ffb3b0656(storage) {
    try {
        for(let index = storage.length - 1; index >= 0; index -= 1){
            const key = storage.key(index);
            if (key === 'bill_physio_consent_v1' || /^Bill_Cookies_(?:[0-9]|1[01])\d{4}$/.test(key)) storage.removeItem(key);
        }
    } catch  {
    // Privacy mode or blocked storage must not prevent navigation/contact.
    }
}
function $0847d0cef0fc0611$export$84f5ffeaf1bf6b2(cookieDocument, location) {
    const domains = [
        '',
        location.hostname
    ];
    if (location.hostname === 'bill-physio.de' || location.hostname.endsWith('.bill-physio.de')) domains.push('bill-physio.de');
    for (const name of [
        '_ga',
        '_ga_MN2KJN5SSK'
    ]){
        for (const domain of new Set(domains))try {
            cookieDocument.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax${domain ? `; Domain=${domain}` : ''}${location.protocol === 'https:' ? '; Secure' : ''}`;
        } catch  {
        // Also tolerate browsers that reject cookie access entirely.
        }
    }
}
function $0847d0cef0fc0611$export$1256492b17bbf5ee(storage, cookieDocument, location) {
    $0847d0cef0fc0611$export$1d29986ffb3b0656(storage);
    $0847d0cef0fc0611$export$84f5ffeaf1bf6b2(cookieDocument, location);
}


const $4de973f30da80bdd$export$3ad120c7b1e94f31 = 'G-MN2KJN5SSK';
const $4de973f30da80bdd$export$cffd5fc3cc43070e = 'bill_physio_visit_consent_v2';
const $4de973f30da80bdd$export$9853ccfbed83a967 = '2026-09-26-ga4-visit-v2';
const $4de973f30da80bdd$export$ae6396dd94989815 = 1800000;
const $4de973f30da80bdd$export$187731a10275777b = 'bill_physio_visit_transition_v2';
function $4de973f30da80bdd$export$6217378d6df936b2(raw, pathname, navigationType, now = Date.now()) {
    try {
        const transition = JSON.parse(raw);
        return transition?.path === pathname && Number.isSafeInteger(transition.timestamp) && transition.timestamp <= now && now - transition.timestamp < 30000 && (transition.type === 'link' && navigationType === 'navigate' || transition.type === 'withdrawal' && navigationType === 'reload');
    } catch  {
        return false;
    }
}
function $4de973f30da80bdd$export$2f8e349497fd72f2(analytics, now = Date.now()) {
    return {
        version: $4de973f30da80bdd$export$9853ccfbed83a967,
        analytics: analytics,
        timestamp: now,
        expiresAt: now + $4de973f30da80bdd$export$ae6396dd94989815
    };
}
function $4de973f30da80bdd$export$bf8500b48db2e63e(raw, now = Date.now()) {
    try {
        const choice = JSON.parse(raw);
        if (choice?.version !== $4de973f30da80bdd$export$9853ccfbed83a967 || typeof choice.analytics !== 'boolean' || !Number.isSafeInteger(choice.timestamp) || choice.timestamp > now || choice.expiresAt !== choice.timestamp + $4de973f30da80bdd$export$ae6396dd94989815 || choice.expiresAt <= now) return null;
        return choice;
    } catch  {
        return null;
    }
}
function $4de973f30da80bdd$export$d098a40339c96cee(location) {
    if (location.protocol !== 'https:' || ![
        'bill-physio.de',
        'www.bill-physio.de'
    ].includes(location.hostname)) return null;
    const pages = {
        '/': [
            '/',
            "Bill Physio \u2013 Startseite"
        ],
        '/index.html': [
            '/',
            "Bill Physio \u2013 Startseite"
        ],
        '/videos.html': [
            '/videos.html',
            "Bill Physio \u2013 Videotraining"
        ],
        '/datenschutz.html': [
            '/datenschutz.html',
            "Bill Physio \u2013 Datenschutz"
        ]
    };
    if (!Object.hasOwn(pages, location.pathname)) return null;
    const [path, title] = pages[location.pathname];
    return {
        page_location: 'https://bill-physio.de' + path,
        page_title: title,
        page_referrer: ''
    };
}


function $1d3d77cf3e8d575c$export$81477481056cb7f0() {
    const disableKey = 'ga-disable-' + (0, $4de973f30da80bdd$export$3ad120c7b1e94f31);
    window[disableKey] = true;
    let storage, channel, choice = null, tagStarted = false, expiryTimer;
    try {
        (0, $0847d0cef0fc0611$export$1d29986ffb3b0656)(window.localStorage);
    } catch  {}
    try {
        storage = window.sessionStorage;
        const transition = storage.getItem((0, $4de973f30da80bdd$export$187731a10275777b));
        storage.removeItem((0, $4de973f30da80bdd$export$187731a10275777b));
        const raw = storage.getItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e));
        const navigationType = performance.getEntriesByType('navigation')[0]?.type;
        choice = (0, $4de973f30da80bdd$export$6217378d6df936b2)(transition, window.location.pathname, navigationType) ? (0, $4de973f30da80bdd$export$bf8500b48db2e63e)(raw) : null;
        // Do not reuse acceptance from read-only storage: withdrawal must remain
        // writable. Rewriting the identical value does not extend its lifetime.
        if (choice) storage.setItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e), raw);
        else if (raw !== null) storage.removeItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e));
    } catch  {
        storage = undefined;
        choice = null;
    }
    const dialog = document.createElement('dialog');
    dialog.className = 'cookie-dialog';
    dialog.setAttribute('aria-labelledby', 'cookie-title');
    dialog.setAttribute('aria-describedby', 'cookie-description');
    dialog.innerHTML = `
        <button type="button" class="cookie-close" aria-label="Ohne Cookies schlie\xdfen">\xd7</button>
        <p class="cookie-eyebrow">BILL PHYSIO \xb7 DATENSCHUTZ</p>
        <h2 id="cookie-title">Ihre Cookie-Auswahl</h2>
        <p id="cookie-description">D\xfcrfen wir Google Analytics f\xfcr freiwillige Besuchsstatistiken verwenden? Damit erfahren wir, wie unsere Website genutzt wird, und k\xf6nnen sie verbessern.</p>
        <p>Bei Zustimmung erh\xe4lt Google Ireland Limited unter anderem Seitenaufrufe, Ger\xe4teinformationen und eine Cookie-Kennung. Eine Verarbeitung in den USA ist m\xf6glich. Ihre Auswahl gilt nur f\xfcr diesen Besuch, h\xf6chstens 30 Minuten. Beim erneuten \xd6ffnen fragen wir wieder.</p>
        <p>Ohne Ihre Zustimmung laden wir Google Analytics nicht. Die Website bleibt nutzbar. Sie k\xf6nnen Ihre Einwilligung jederzeit \xfcber <strong>Cookie-Einstellungen</strong> widerrufen.</p>
        <p><a href="datenschutz.html#statistik">Details in der Datenschutzerkl\xe4rung</a> \xb7 <a href="index.html#impressum" data-impressum-link>Impressum</a></p>
        <p class="cookie-status" aria-live="polite"></p>
        <div class="cookie-actions">
            <button type="button" class="cookie-choice" data-consent="deny">Cookies ablehnen</button>
            <button type="button" class="cookie-choice" data-consent="allow">Cookies erlauben</button>
        </div>`;
    document.body.append(dialog);
    const status = dialog.querySelector('.cookie-status');
    function isReadingLegalNotice() {
        return window.location.pathname.endsWith('/datenschutz.html') || [
            '/',
            '/index.html'
        ].includes(window.location.pathname) && window.location.hash === '#impressum';
    }
    function readChoice() {
        if (storage) try {
            const raw = storage.getItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e));
            const stored = (0, $4de973f30da80bdd$export$bf8500b48db2e63e)(raw);
            if (stored) storage.setItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e), raw);
            else if (raw !== null) storage.removeItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e));
            return stored;
        } catch  {
            storage = undefined;
        }
        return (0, $4de973f30da80bdd$export$bf8500b48db2e63e)(JSON.stringify(choice));
    }
    function openSettings() {
        status.textContent = choice?.analytics === true ? "Aktuell: Cookies erlaubt. Mit \u201ECookies ablehnen\u201C widerrufen Sie Ihre Einwilligung." : choice?.analytics === false ? 'Aktuell: Cookies abgelehnt.' : 'Aktuell: Google Analytics ist deaktiviert.';
        if (!dialog.open) dialog.showModal();
    }
    function rememberTransition(path, type) {
        if (!choice) return;
        try {
            storage?.setItem((0, $4de973f30da80bdd$export$187731a10275777b), JSON.stringify({
                path: path,
                type: type,
                timestamp: Date.now()
            }));
        } catch  {}
    }
    function stopAnalytics() {
        // Setting denied via the loaded Google tag could itself send cookieless
        // pings. Disable it first, discard queued work, then unload it by reloading.
        window[disableKey] = true;
        window.gtag = ()=>{};
        window.dataLayer = [];
        document.getElementById('bill-analytics')?.remove();
        (0, $0847d0cef0fc0611$export$84f5ffeaf1bf6b2)(document, window.location);
        if (tagStarted) {
            if (choice?.analytics === false) rememberTransition(window.location.pathname, 'withdrawal');
            window.location.reload();
        }
    }
    function startAnalytics() {
        const page = (0, $4de973f30da80bdd$export$d098a40339c96cee)(window.location);
        if (tagStarted || choice?.analytics !== true || !page) return;
        tagStarted = true;
        window[disableKey] = false;
        window.dataLayer = [];
        window.gtag = function() {
            window.dataLayer.push(arguments);
        };
        const advertisingDenied = {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
        };
        window.gtag('consent', 'default', {
            ...advertisingDenied,
            analytics_storage: 'denied'
        });
        window.gtag('consent', 'update', {
            ...advertisingDenied,
            analytics_storage: 'granted'
        });
        window.gtag('set', {
            ...page,
            ads_data_redaction: true,
            url_passthrough: false,
            allow_google_signals: false,
            allow_ad_personalization_signals: false
        });
        window.gtag('js', new Date());
        window.gtag('config', (0, $4de973f30da80bdd$export$3ad120c7b1e94f31), {
            ...page,
            send_page_view: false,
            allow_google_signals: false,
            allow_ad_personalization_signals: false,
            cookie_expires: 0,
            cookie_update: false,
            cookie_domain: window.location.hostname,
            cookie_flags: 'SameSite=Lax;Secure'
        });
        window.gtag('event', 'page_view', {
            ...page,
            send_to: (0, $4de973f30da80bdd$export$3ad120c7b1e94f31)
        });
        const script = document.createElement('script');
        script.id = 'bill-analytics';
        script.async = true;
        script.referrerPolicy = 'no-referrer';
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + (0, $4de973f30da80bdd$export$3ad120c7b1e94f31);
        document.head.append(script);
    }
    function scheduleExpiry() {
        window.clearTimeout(expiryTimer);
        if (!choice) return;
        expiryTimer = window.setTimeout(refreshChoice, Math.max(1, choice.expiresAt - Date.now()));
    }
    function refreshChoice() {
        choice = readChoice();
        if (choice?.analytics === true) startAnalytics();
        else stopAnalytics();
        scheduleExpiry();
        if (!choice && !isReadingLegalNotice()) openSettings();
    }
    function choose(analytics, broadcast = true) {
        choice = (0, $4de973f30da80bdd$export$2f8e349497fd72f2)(analytics);
        try {
            storage?.setItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e), JSON.stringify(choice));
        } catch  {
            // A full/blocked store must not leave an old acceptance behind.
            try {
                storage?.removeItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e));
            } catch  {}
            storage = undefined;
        }
        dialog.close();
        if (!analytics && broadcast) try {
            channel?.postMessage('deny');
        } catch  {}
        if (analytics) startAnalytics();
        else stopAnalytics();
        scheduleExpiry();
    }
    dialog.querySelector('[data-consent="allow"]').addEventListener('click', ()=>choose(true));
    dialog.querySelector('[data-consent="deny"]').addEventListener('click', ()=>choose(false));
    dialog.querySelector('.cookie-close').addEventListener('click', ()=>choose(false));
    // Reading the Impressum is neither acceptance nor refusal. Also close when
    // the link targets the current document, where no initialization runs again.
    dialog.querySelector('[data-impressum-link]').addEventListener('click', ()=>dialog.close());
    dialog.addEventListener('cancel', (event)=>{
        event.preventDefault();
        choose(false);
    });
    document.querySelectorAll('[data-cookie-settings]').forEach((button)=>{
        button.hidden = false;
        button.addEventListener('click', openSettings);
    });
    // A new tab needs its own choice. Only refusals, never acceptances, propagate.
    try {
        channel = new BroadcastChannel('bill_physio_privacy_v2');
        channel.addEventListener('message', (event)=>{
            if (event.data === 'deny' && choice?.analytics === true) choose(false, false);
        });
    } catch  {}
    document.addEventListener('click', (event)=>{
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href]');
        if (!link || link.hasAttribute('download') || link.target && link.target !== '_self') return;
        const destination = new URL(link.href, window.location.href);
        if (destination.origin !== window.location.origin || ![
            '/',
            '/index.html',
            '/videos.html',
            '/datenschutz.html'
        ].includes(destination.pathname)) return;
        if (destination.pathname === window.location.pathname && destination.search === window.location.search) return;
        rememberTransition(destination.pathname, 'link');
    });
    // A restored page may keep its old JS heap. Disable the tag before it is
    // frozen, then discard the old choice when the browser brings it back.
    window.addEventListener('pagehide', ()=>{
        window[disableKey] = true;
    });
    window.addEventListener('pageshow', (event)=>{
        if (!event.persisted) return;
        choice = null;
        try {
            storage?.removeItem((0, $4de973f30da80bdd$export$cffd5fc3cc43070e));
            storage?.removeItem((0, $4de973f30da80bdd$export$187731a10275777b));
        } catch  {
            storage = undefined;
        }
        stopAnalytics();
        scheduleExpiry();
        if (!isReadingLegalNotice()) openSettings();
    });
    window.addEventListener('hashchange', ()=>{
        if (isReadingLegalNotice() && dialog.open) dialog.close();
    });
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible') refreshChoice();
    });
    if (choice?.analytics === true) startAnalytics();
    else (0, $0847d0cef0fc0611$export$84f5ffeaf1bf6b2)(document, window.location);
    scheduleExpiry();
    // Both legal notices must remain readable before making a choice.
    if (!choice && !isReadingLegalNotice()) openSettings();
}


(0, $1d3d77cf3e8d575c$export$81477481056cb7f0)();
const $b40b59b4da3617c0$var$navigation = document.getElementById('navbar-toggle');
const $b40b59b4da3617c0$var$toggle = document.querySelector('.navbar-toggler');
function $b40b59b4da3617c0$var$closeNavigation() {
    $b40b59b4da3617c0$var$navigation?.classList.remove('show');
    $b40b59b4da3617c0$var$toggle?.setAttribute('aria-expanded', 'false');
}
$b40b59b4da3617c0$var$toggle?.addEventListener('click', ()=>{
    const expanded = $b40b59b4da3617c0$var$navigation.classList.toggle('show');
    $b40b59b4da3617c0$var$toggle.setAttribute('aria-expanded', String(expanded));
});
$b40b59b4da3617c0$var$navigation?.addEventListener('click', (event)=>{
    if (event.target.closest('a')) $b40b59b4da3617c0$var$closeNavigation();
});
document.addEventListener('keydown', (event)=>{
    if (event.key === 'Escape' && $b40b59b4da3617c0$var$navigation?.classList.contains('show')) {
        $b40b59b4da3617c0$var$closeNavigation();
        $b40b59b4da3617c0$var$toggle.focus();
    }
});
const $b40b59b4da3617c0$var$backToTop = document.getElementById('back-to-top-button');
const $b40b59b4da3617c0$var$headerNavigation = document.querySelector('nav.navbar');
if ($b40b59b4da3617c0$var$headerNavigation) {
    const syncHeaderHeight = ()=>document.documentElement.style.setProperty('--header-height', `${$b40b59b4da3617c0$var$headerNavigation.getBoundingClientRect().height}px`);
    syncHeaderHeight();
    new ResizeObserver(syncHeaderHeight).observe($b40b59b4da3617c0$var$headerNavigation);
}
function $b40b59b4da3617c0$var$updateScroll() {
    document.querySelector('nav.navbar')?.classList.toggle('bg-white', window.scrollY > 70);
    $b40b59b4da3617c0$var$backToTop?.classList.toggle('d-inline', window.scrollY > 70);
}
window.addEventListener('scroll', $b40b59b4da3617c0$var$updateScroll, {
    passive: true
});
$b40b59b4da3617c0$var$updateScroll();
document.querySelectorAll('[data-year]').forEach((element)=>{
    element.textContent = String(new Date().getFullYear());
});


//# sourceMappingURL=bill.cd0b3a42.js.map
